import React from 'react';

import {SEGREGATION_TERMS} from '../../../constants/parameterization';
import {
  ALIMENTACAO,
  CULTURA,
  FROTA,
  MOBILIDADE,
  MULTIBENEFICIOS_LIMITE,
  MULTIBENEFICIOS_SALDO,
  NATAL,
  REFEICAO,
  ALIMENTACAO_PAT,
  REFEICAO_PAT
} from '../../../constants/products';
import {useGetParameterization} from '../../../hooks/useGetParameterization';
import {
  getConditionAnnualFee,
  getConditionMdr,
  getConditionMembershipFee,
  getConditionSaleDeadline,
  getConditionTor,
  getProductName
} from '../../../services/terms/terms';
import {useParameterizationStore} from '../../../store/slices/parameterizationStore';
import {useTermsStore} from '../../../store/slices/termsStore';
import {formatCnpj} from '../../../utils';

const MealCard = '/cards/refeicao-card-v2.png';
const FoodCard = '/cards/alimentacao-card-v2.png';
const MultibenefitCard = '/cards/mult-card-v3.png';
const ChristmasCard = '/cards/natal-card-v2.png';
const CultureCard = '/cards/cultura-card-v2.png';
const FleetCard = '/cards/frota-card-v2.png';
const MobilityCard = '/cards/mobi-card-v2.png';
import './TableProductsTermsConditions.style.scss';
import TooltipButton from '../../TooltipButton/TooltipButton';

export const TableProductsTermsConditions = () => {
  const commercialConditionsSelected = useTermsStore(
    (state) => state.commercialConditionsSelected
  );
  const segregationTerms = useParameterizationStore(
    (state) => state.segregationTerms
  );

  useGetParameterization(SEGREGATION_TERMS);

  const getProductIcon = (productCode) => {
    switch (Number.parseInt(productCode, 10)) {
      case REFEICAO:
        return MealCard;
      case ALIMENTACAO:
        return FoodCard;
      case REFEICAO_PAT:
        return MealCard;
      case ALIMENTACAO_PAT:
        return FoodCard;
      case MULTIBENEFICIOS_LIMITE:
        return MultibenefitCard;
      case MULTIBENEFICIOS_SALDO:
        return MultibenefitCard;
      case FROTA:
        return FleetCard;
      case NATAL:
        return ChristmasCard;
      case CULTURA:
        return CultureCard;
      case MOBILIDADE:
        return MobilityCard;
      default:
        return '';
    }
  };

  const testCompanyExist = (product) => {
    if (product.company) {
      return formatCnpj(product.company.documentNumber);
    }

    return '';
  };

  return (
    <div className="table-content">
      <table className="table-products" aria-label="Informações de produtos">
        <thead>
          <tr>
            <th>
              <div className="table-products--margin-left-24">PRODUTO</div>
            </th>
            <th>COMISSÃO DE SERVIÇO</th>
            <th>PRAZO DE RECEBIMENTO</th>
            <th />
            <th>TARIFA DE ADESÃO</th>
            <th>TARIFA OPERACIONAL (TOR)</th>
            <th>TARIFA DE ANUIDADE</th>

            {segregationTerms && (
              <th className="table-products--min-col-cnpj">
                OPERADO PELO CNPJ
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {commercialConditionsSelected
            .toSorted((p1, p2) => p1.productCode - p2.productCode)
            .map((product) => {
              return (
                <tr key={product.productCode}>
                  <td>
                    <div className="table-products__product-box">
                      <div className="table-products__icon-box">
                        <img
                          src={getProductIcon(product.productCode)}
                          className="table-products--width-100"
                          alt={`Imagem do Cartão de ${getProductName(product.productCode)}`}
                        />
                      </div>
                      <div className="table-products__legend-box">
                        {!segregationTerms && <span>Alelo</span>}
                        <strong className="table-products__card-name">
                          {getProductName(product.productCode)}
                        </strong>
                      </div>
                    </div>
                  </td>
                  <td>
                    <p>{getConditionMdr(product.commercialConditions)}</p>
                  </td>
                  <td>
                    <p>
                      {getConditionSaleDeadline(product.commercialConditions)}
                    </p>
                  </td>
                  <td>
                    <p>
                      {getProductName(product.productCode).includes(
                        'MULTIBENEFÍCIOS'
                      ) && (
                        <TooltipButton info="O prazo contratado para recebimento é de 30 dias corridos. Contudo, temporariamente, o recebimento irá ocorrer em 2 dias corridos. Tão logo seja possível, reestabeleceremos o prazo contratado de recebimento acordado." />
                      )}
                    </p>
                  </td>
                  <td>
                    <p>
                      R$
                      {getConditionMembershipFee(product.commercialConditions)}
                    </p>
                  </td>
                  <td>
                    <p data-aut-test="taxa">
                      R${getConditionTor(product.commercialConditions)}
                    </p>
                  </td>
                  <td>
                    <p>
                      R${getConditionAnnualFee(product.commercialConditions)}
                    </p>
                  </td>
                  {segregationTerms && (
                    <td>
                      <p>{testCompanyExist(product)}</p>
                    </td>
                  )}
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
};
